export default "__VITE_ASSET__BxuaA1zP__"